import {EditorState, Modifier, SelectionState} from 'draft-js';
import type {ContentState} from 'draft-js';

interface InsertMentionParams {
	id: string;
	name: string;
	triggerStart: number;
}

export function insertMention(editorState: EditorState, params: InsertMentionParams): EditorState {
	const {id, name, triggerStart} = params;
	const content = editorState.getCurrentContent();
	const selection = editorState.getSelection();
	const blockKey = selection.getAnchorKey();
	const cursorOffset = selection.getAnchorOffset();

	const replaceSelection = SelectionState.createEmpty(blockKey).merge({
		anchorOffset: triggerStart,
		focusOffset: cursorOffset,
	}) as SelectionState;

	const contentWithEntity = content.createEntity('MENTION', 'IMMUTABLE', {
		userId: id,
		name,
	});
	const entityKey = contentWithEntity.getLastCreatedEntityKey();

	const mentionText = name;
	const contentWithMention = Modifier.replaceText(contentWithEntity, replaceSelection, mentionText, undefined, entityKey);

	const afterMentionSelection = SelectionState.createEmpty(blockKey).merge({
		anchorOffset: triggerStart + mentionText.length,
		focusOffset: triggerStart + mentionText.length,
	}) as SelectionState;

	const contentWithSpace = Modifier.insertText(contentWithMention, afterMentionSelection, ' ');

	const newEditorState = EditorState.push(editorState, contentWithSpace, 'insert-characters');

	const finalSelection = SelectionState.createEmpty(blockKey).merge({
		anchorOffset: triggerStart + mentionText.length + 1,
		focusOffset: triggerStart + mentionText.length + 1,
	}) as SelectionState;

	return EditorState.forceSelection(newEditorState, finalSelection);
}

export function extractMentionIds(contentState: ContentState): string[] {
	const ids = new Set<string>();

	contentState.getBlockMap().forEach(block => {
		if (!block) return;
		block.findEntityRanges(
			char => {
				const entityKey = char.getEntity();
				if (!entityKey) return false;
				const entity = contentState.getEntity(entityKey);
				return entity.getType() === 'MENTION';
			},
			start => {
				const entityKey = block.getEntityAt(start);
				if (!entityKey) return;
				const entity = contentState.getEntity(entityKey);
				const data = entity.getData() as {userId: string};
				ids.add(data.userId);
			}
		);
	});

	return [...ids];
}
